<template>
  <div class="homeCon"
       ref="homeBox">
    <div v-if="collectList.length === 0" class="noClooectContainer">
      <img src="../../assets/noCollect.png" alt="" class="noClooectIcon">
    </div>
    <div v-else>
      <div class="categoryContainer"
         v-if="device !== 'mobile'">
      <div class="category-right">
        <div class="category-childs-item"
             v-for="(item, index) in collectList"
             :key="index + item.id"
             @click="toScene(item)"
             @mouseenter="item.isShowInfo = true"
             @mouseleave="item.isShowInfo = false"
             >
          <img :src="item.base64Pic" class="coverImg">
          <div class="item-title" v-if="item.isShowInfo">
            {{item.name}}
          </div>
          <div class="delete" v-if="item.isShowInfo" @click.stop="deleteCollect(item.id)">
            <img src="../../assets/deleteIcon.jpg" alt="">
          </div>
        </div>
      </div>
      <div class="paginationContainer">
        <img src="../../assets/pagination-prev.jpg" alt="" @click="changePage('prev')">
        <div v-for="(item, index) in pageList" :key="'page' + item" class="paginationItem" :class="{'checkedPage': index === pageIndex}" @click="changePage('pageCount', item)">{{item}}</div>
        <img src="../../assets/pagination-next.jpg" alt="" @click="changePage('next')">
      </div>
    </div>
    <div class="categoryMobileContainer"
         v-else
         :style="{'minHeight': categoriesContainerMinHeight + 'px'}">
      <div class="category-middle">
        <div class="category-childs-item"
             v-for="(item, index) in collectList"
             :key="index + item.id">
          <img :src="item.base64Pic"
               @click="toScene(item)">
          <div class="item-title">
            {{item.name}}
          </div>
          <div class="delete" @click.stop="deleteCollect(item.id)">
            <img src="../../assets/deleteIcon.jpg" alt="">
          </div>
        </div>
      </div>
      <div class="paginationContainer">
      <img src="../../assets/pagination-prev.jpg" alt="" @click="changePage('prev')">
      <div v-for="(item, index) in pageList" :key="'page' + item" class="paginationItem" :class="{'checkedPage': index === pageIndex}" @click="changePage('pageCount', item)">{{item}}</div>
      <img src="../../assets/pagination-next.jpg" alt="" @click="changePage('next')">
    </div>
    </div>
    </div>

  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { mapState } from 'vuex'
import { fetchList } from '@/api/list'
import store from '../../../store'
const host = 'https://3d.gtlander.com'

export default {
  name: 'ThreedCategory',
  computed: {
    ...mapState({
      device: state => state.app.device,
      categoryParentsId: state => state.app.categoryParentsId,
      collectOffset: state => state.app.collectOffset
    })
  },
  data () {
    return {
      collectList: [],
      totalCount: 0,
      pageList: [],
      pageIndex: 0,
      categoriesContainerMinHeight: 0
    }
  },
  mounted () {
    if (!Cookies.get('jwt')) {
      this.$router.push({ name: 'home' })
    }
    if (this.device !== 'mobile') {
      this.categoryRightWidth = document.documentElement.clientWidth - 600
      this.imgHeight = (document.documentElement.clientWidth - 600) * 0.32 * 0.55
      this.categoryChildsHeight = this.imgHeight + 35
    } else {
      this.imgMibileHeight = (document.documentElement.clientWidth - 60) * 0.47 * 0.6
      this.categoriesContainerMinHeight = document.documentElement.clientHeight - 120
    }
    window.onresize = () => {
      return (() => {
        if (this.device !== 'mobile') {
          this.categoryRightWidth = document.documentElement.clientWidth - 600
          this.imgHeight = (document.documentElement.clientWidth - 600) * 0.32 * 0.55
          this.categoryChildsHeight = this.imgHeight + 35
        } else {
          this.imgMibileHeight = (document.documentElement.clientWidth - 60) * 0.47 * 0.6
          this.categoriesContainerMinHeight = document.documentElement.clientHeight - 120
        }
      })()
    }
    this.getCollectList()
  },
  methods: {
    toScene: function (item) {
      store.dispatch('app/setCollectInfo', item.detailInfo)
      this.$router.push({ name: `3DCollectDetail` })
    },
    getCollectList: function () {
      const { collectOffset } = this
      const query = `
        query{
          getMyColletions(
            paging: {
              offset: ${collectOffset},
              limit: 8
            }
          ){
            collections{
              id,
              name,
              detailInfo,
              base64Pic
            },
            paging{
              totalCount,
              currentOffset,
              currentLimit
            }
          }
        }
      `
      fetchList(query).then(response => {
        const list = response.data.data.getMyColletions.collections
        list.forEach((item) => {
          item.isShowInfo = false
        })
        this.collectList = list
        this.totalCount = response.data.data.getMyColletions.paging.totalCount
        this.paginationInit(response.data.data.getMyColletions.paging.totalCount)
      })
    },
    paginationInit: function (total) {
      const length = Math.ceil(total / 8)
      this.pageList = Array.from(new Array(length).keys(), x => x + 1)
      this.pageIndex = parseInt(this.collectOffset / 8)
    },
    changePage: function (type, count) {
      const { totalCount, collectOffset } = this
      let currentOffset = 0
      switch (type) {
        case 'prev':
          currentOffset = Number(collectOffset) - 8 >= 0 ? Number(collectOffset) - 8 : 0
          break
        case 'next':
          currentOffset = Number(collectOffset) + 8 >= totalCount ? Number(collectOffset) : Number(collectOffset) + 8
          break
        case 'pageCount':
          currentOffset = (count - 1) * 8
          break
        default:
          break
      }
      console.log(currentOffset)
      store.dispatch('app/setCollectOffset', currentOffset)
      this.getCollectList()
    },
    deleteCollect: function (id) {
      this.$confirm(this.$t('threeDScene.deleteText'), this.$t('threeDScene.prompt'), {
        confirmButtonText: this.$t('login.confirm'),
        cancelButtonText: this.$t('login.cancel'),
        type: 'warning'
      }).then(() => {
        this.confirmDel(id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('threeDScene.deleteCancelText')
        })
      })
    },
    confirmDel: function (id) {
      const query = `
        mutation{
          deleteCollection(
            id: ${id}
          )
        }
      `
      fetchList(query).then(response => {
        if (response.data.data.deleteCollection) {
          this.getCollectList()
          this.$message({
            type: 'success',
            message: this.$t('threeDScene.deleteSuccessText')
          })
        } else {
          this.$message({
            message: this.$t('threeDScene.deleteFailText'),
            type: 'warning'
          })
        }
      })
    },
    changeChildList: function (id) {
      for (const m in this.categoriesList) {
        this.categoriesList[m].isChecked = false
        if (this.categoriesList[m].id === id) {
          this.categoriesList[m].isChecked = true
        }
      }
      store.dispatch('app/setCategoryParentsId', id)
      this.getSceneInfo()
    },
    getSceneInfo: function () {
      const { categoryParentsId } = this
      const that = this
      this.$axios.get(host + `/api/category/scenes/${categoryParentsId}`)
        .then(function (response) {
          for (const i in response.data.data) {
            response.data.data[i].cover = host + '/upload/' + response.data.data[i].cover
          }
          that.imgList = response.data.data
          console.log(that.imgList)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/Global.scss";
.homeCon {
  width: 100%;
  height: 100%;
  background: #1e2441;
}
.swiper {
  width: 100%;
  height: 50vh;
  overflow: hidden;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}
.swiper-slide {
  width: auto;
  height: 100%;
  background: white;
  position: relative;
}
.swiper-slide img {
  margin-top: 0;
  width: auto;
  height: 100%;
}
.title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #e73216;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: white;
  left: 0;
  bottom: 0;
  position: absolute;
}
.categoryContainer {
  padding: 80px 140px 0;
  background: #1e2441;
  .category-left {
    height: 100%;
    margin-right: 220px;
    .category-parents-item {
      cursor: pointer;
      width: 100px;
      height: 35px;
      line-height: 35px;
      text-align: center;
      color: white;
      font-size: 16px;
      margin-bottom: 20px;
    }
  }
  .category-right {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-content: flex-start;
    width: 100%;
    height: calc( (100vw - 580px) * 0.24 * 2 + 40px );
    .category-childs-item {
      margin-bottom: 20px;
      cursor: pointer;
      width: 24%;
      margin-right: 1%;
      position: relative;
      .coverImg {
        width: 100%;
        object-fit: cover;
        background: white;
        display: block;
        height: calc( (100vw - 580px) * 0.24 );
      }
      .item-title {
        background: rgba($color: #000000, $alpha: 0.5);
        line-height: 20px;
        color: white;
        font-size: 13px;
        height: 40px;
        padding: 5px 10px;
        position: absolute;
        bottom:0;
        text-align: center;
        width: calc( (100vw - 580px) * 0.24 - 20px );
      }
      .delete{
        width: 30px;
        height: 30px;
        position: absolute;
        top: 0;
        right: 0;
        text-align: center;
        img{
          width: 30px;
          height: 30px;
        }
      }
    }
  }
}
.categoryMobileContainer {
  padding: 120px 30px 0;
  background: #1e2441;
  .category-top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .category-parents-item {
      cursor: pointer;
      width: 30%;
      height: 28px;
      line-height: 28px;
      text-align: center;
      color: white;
      font-size: 14px;
      margin-bottom: 40px;
    }
  }
  .category-middle {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .category-childs-item {
      margin-bottom: 20px;
      cursor: pointer;
      width: 47%;
      position: relative;
      img {
        width: 100%;
        object-fit: scale-down;
        background: white;
        display: block;
      }
      .item-title {
        background: #e73216;
        line-height: 20px;
        color: white;
        font-size: 12px;
        height: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .delete{
        width: 20px;
        height: 20px;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 100;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
.normalColor {
  background: #e73216;
}
.checkedColor {
  background: #ff593f;
}
.second-left-nav {
  z-index: 999;
  position: absolute;
  left: 0;
  top: 0;
}
.paginationContainer{
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
  img{
    width: 30px;
    height: 30px;
    margin-right: 15px;
    cursor: pointer;
  }
  .paginationItem{
    width: 30px;
    height: 30px;
    background: rgba($color: #e73216, $alpha: 0.5);
    color: #1e2441;
    font-weight: bolder;
    margin-right: 15px;
    font-size: 20px;
    line-height: 30px;
    cursor: pointer;
  }
  .checkedPage{
    background: rgba($color: #e73216, $alpha: 1) !important;
  }
}
.noClooectIcon{
  width: 5%;
  opacity: 0.1;
  margin-top: 22%;
}
.noClooectContainer{
  min-height: 100vh;
}
</style>
